<section class="recruiter-cta">
  <div class="recruiter-cta__container">
    <div class="recruiter-cta__card">

      <!-- Background floating shapes -->
      <div class="recruiter-cta__shape recruiter-cta__shape--1"></div>
      <div class="recruiter-cta__shape recruiter-cta__shape--2"></div>
      <div class="recruiter-cta__shape recruiter-cta__shape--3"></div>
      <div class="recruiter-cta__shape recruiter-cta__shape--4"></div>
      <div class="recruiter-cta__shape recruiter-cta__shape--5"></div>

      <!-- Content -->
      <div class="recruiter-cta__content">
        <!-- Top Badge -->
        <div class="recruiter-cta__badge">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          Trusted by 10+ companies
        </div>

        <!-- Title -->
        <h2 class="recruiter-cta__title">
          Hire smarter <span class="recruiter-cta__title-light">with AI</span>
        </h2>

        <!-- Subtitle -->
        <p class="recruiter-cta__subtitle">
          Transform your recruitment process with intelligent hiring workflows, AI interviews, assessments and real-time
          analytics.
        </p>

        <!-- Action Buttons -->
        <div class="recruiter-cta__actions">
          <button class="recruiter-cta__btn recruiter-cta__btn--primary" (click)="openModal('demo')">
            Book Demo <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </button>
          <button class="recruiter-cta__btn recruiter-cta__btn--secondary" (click)="openModal('quote')">
            Get Quote
          </button>
        </div>
      </div>

    </div>

  </div>
</section>

<!-- Demo Modal -->
<app-book-demo-modal *ngIf="isDemoModalOpen" [initialOption]="initialModalOption" (close)="closeModal()">
</app-book-demo-modal>